import { useCallback, useState } from "react";
import { SettingsIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";
import AccountCharDeleteContainer from "@/domains/account/containers/char/AccountCharDeleteContainer";
import AccountCharSupportContainer from "@/domains/account/containers/char/AccountCharSupportContainer";
import AccountCharSettings from "@/domains/account/components/char/AccountCharSettings";

export default function AccountCharSettingsContainer() {
  const [isSettingsOpen, setSettingsOpen] = useState(false);

  const onToggleOpen = useCallback(() => {
    setSettingsOpen((state) => !state);
  }, []);

  return (
    <>
      <Button type="button" variant="soft" color="gray" onClick={onToggleOpen}>
        <SettingsIcon size={18} className="mr-2.5" />
        Настройки персонажа
      </Button>
      <AccountCharSettings open={isSettingsOpen} onClose={onToggleOpen}>
        <AccountCharDeleteContainer />
        <AccountCharSupportContainer />
      </AccountCharSettings>
    </>
  );
}
